import { render } from "./editPermission.vue?vue&type=template&id=033cecfd&scoped=true"
import script from "./editPermission.vue?vue&type=script&lang=js"
export * from "./editPermission.vue?vue&type=script&lang=js"

import "./editPermission.vue?vue&type=style&index=0&id=033cecfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033cecfd"]])

export default __exports__